<template>
  <div class="card" style="position:relative">
    <b-button
      @click="selectedMap = null"
      v-if="selectedMap"
      style="position: absolute; top: 4%; left: 3%; z-index: 10;"
      type="is-dark"
      size="is-small"
      outlined
      >Back</b-button
    >

    <div class="box has-text-centered" v-if="loading">
      Requesting seat maps...
    </div>
    <SeatMap
      v-else-if="selectedMap"
      :seatmap="selectedMap"
      :preview="preview"
      @selected="selectSeat"
      :passenger="passenger"
    ></SeatMap>
    <div class="box wdt" v-else>
      <div class="mb-5">
        <button
          type="button"
          class="delete is-pulled-right"
          @click="$emit('close')"
        />
        <h1 class="is-size-3 ">Select flight</h1>
      </div>
      <div v-if="journeys.length == 1">
        <div
          v-for="flight in journeys[0].legs"
          :key="flight.legIndex"
          class="mb-5"
        >
          <div class="columns is-mobile" style="width: 100%;">
            <div class="column is-7">
              <h1 class="is-size-3">
                {{ flight.departingAirport }} - {{ flight.arrivingAirport }}
              </h1>
              <h2 class="is-size-5 has-text-grey">
                Flight #{{ flight.marketingAirline.code
                }}{{ flight.flightNumber }}
              </h2>
              <h3 class="is-size-6 has-text-grey">
                Departing {{ flight.departingAt.date | formatDate }}
              </h3>
              <p></p>
            </div>
            <div class="column is-5">
              <div v-if="!flight.selectedSeat" style="margin-top: 35%;">
                <b-button
                  v-if="
                    hasSeats(journey.segmentIndex - 1, flight.legIndex - 1)
                  "
                  class="is-block"
                  style="margin: auto;"
                  size="is-small"
                  @click="goToSeatMap(findId(0, flight.legIndex - 1))"
                  type="is-primary"
                  outlined
                  expanded
                  ><div v-if="preview">
                    View Seats
                  </div>
                  <div v-else>
                    Select Seat
                  </div></b-button
                >
                <b-button
                  v-else
                  :disabled="true"
                  type="is-dark"
                  size="is-small"
                  expanded
                  >Seat map unavailable</b-button
                >
              </div>
              <div v-else style="margin-top: 20%;">
                <div style="margin-bottom: 5px;">
                  <h1 class="is-size-6">
                    Selected seat:
                    <b class="is-size-5">{{ flight.selectedSeat.id }}</b>
                  </h1>
                </div>
                <b-button
                  class="is-block"
                  style="margin: auto;"
                  size="is-small"
                  @click="goToSeatMap(findId(0, flight.legIndex - 1))"
                  type="is-primary"
                  outlined
                  expanded
                  >Edit Selection</b-button
                >
                <!-- <a style="margin:auto;" @click="goToSeatMap(flight.legIndex - 1)"> Edit Selection </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs v-else v-model="tab" type="is-boxed">
        <b-tab-item
          v-for="journey in journeys"
          :key="journey.uniqueKey"
          :label="journey.from + ' - ' + journey.to"
        >
          <div
            v-for="flight in journey.legs"
            :key="flight.legIndex"
            class="mb-5"
          >
            <div class="columns is-mobile" style="width: 100%;">
              <div class="column is-7">
                <h1 class="is-size-3">
                  {{ flight.departingAirport }} - {{ flight.arrivingAirport }}
                </h1>
                <h2 class="is-size-5 has-text-grey">
                  Flight #{{ flight.marketingAirline.code
                  }}{{ flight.flightNumber }}
                </h2>
                <h3 class="is-size-6 has-text-grey">
                  Departing {{ flight.departingAt.date | formatDate }}
                </h3>
                <p></p>
              </div>
              <div class="column is-5">
                <div v-if="!flight.selectedSeat" style="margin-top: 35%;">
                  <b-button
                    v-if="
                      hasSeats(journey.segmentIndex - 1, flight.legIndex - 1)
                    "
                    class="is-block"
                    style="margin: auto;"
                    size="is-small"
                    @click="
                      goToSeatMap(
                        findId(journey.segmentIndex - 1, flight.legIndex - 1)
                      )
                    "
                    type="is-primary"
                    outlined
                    expanded
                    ><div v-if="preview">
                      View Seats
                    </div>
                    <div v-else>
                      Select Seat
                    </div></b-button
                  >
                  <b-button
                    v-else-if="
                      getLoadingStatus(
                        findId(journey.segmentIndex - 1, flight.legIndex - 1)
                      )
                    "
                    :disabled="true"
                    type="is-primary"
                    size="is-small"
                    expanded
                  >
                    Loading seat map...
                  </b-button>
                  <b-button
                    v-else
                    :disabled="true"
                    type="is-dark"
                    size="is-small"
                    expanded
                    >Seat map unavailable
                  </b-button>
                </div>
                <div v-else style="margin-top: 20%;">
                  <div style="margin-bottom: 5px;">
                    <h1 class="is-size-6">
                      Selected seat:
                      <b class="is-size-5">{{ flight.selectedSeat.id }}</b>
                    </h1>
                  </div>
                  <b-button
                    class="is-block"
                    style="margin: auto;"
                    size="is-small"
                    @click="
                      goToSeatMap(
                        findId(journey.segmentIndex - 1, flight.legIndex - 1)
                      )
                    "
                    type="is-primary"
                    outlined
                    expanded
                    >Edit Selection</b-button
                  >
                  <!-- <a style="margin:auto;" @click="goToSeatMap(flight.legIndex - 1)"> Edit Selection </a> -->
                </div>
              </div>
            </div>
          </div>
        </b-tab-item>
        <!-- <b-tab-item label="Music" icon="library-music"></b-tab-item>
            <b-tab-item label="Videos" icon="video"></b-tab-item> -->
      </b-tabs>

      <div v-if="!preview" class="mt-6">
        <b-button
          class="is-block"
          style="margin: auto;"
          @click="$emit('close')"
          type="is-primary"
          expanded
          >Close Seat Viewer</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// import Row from './Row.vue'
// import FlightDetails from './FlightDetails'
import SeatMap from "./SeatMap.vue";
export default {
  components: {
    SeatMap,
  },
  props: {
    activeTab: Number,
    flight: Object,
    flightProp: [Array, Object],
    preview: Boolean,
    guestIndex: Number,
  },
  data: function() {
    return {
      name: "seatMapMenu",
      seatMaps: [],
      loadStatus: [], //the loading status of each seat map
      tab: 1,
      selectedMap: null,
      loading: true,
      passenger: {
        id: 1,
        name: "",
      },
      //aisleLeftColumn: null,
      //aisleRightColumn: null
    };
  },
  computed: {
    journeys() {
      return this.flight.journeys;
    },
    segmentMatrix() {
      let matrix = [];
      let index = 0;

      for (let j = 0; j < this.journeys.length; j++) {
        let journey = this.journeys[j];
        let legs = [];
        for (let l = 0; l < journey.legs.length; l++) {
          legs[l] = index;
          index++;
        }
        matrix[j] = legs;
      }
      return matrix;
    },
  },
  methods: {
    selectSeat(selectedSeat) {
      console.log(selectedSeat);
      //var indices = this.selectedMap.segmentIndex.split(".");
      let indices = this.findIndices(this.selectedMap);

      selectedSeat.journeyIndex = indices[0];
      selectedSeat.legIndex = indices[1];
      selectedSeat.responseId = this.selectedMap.responseId ?? null;
      selectedSeat.offerId = this.selectedMap.offerId ?? null;

      if (typeof this.guestIndex !== "undefined") {
        let payload = {};
        payload.guestIndex = this.guestIndex;
        payload.selectedSeat = selectedSeat;
        this.$store.commit("bookTravel/ADD_SEAT_GUEST", payload);
        console.log("is a guest");
        console.log(payload);
      } else {
        this.$store.commit("bookTravel/ADD_SEAT", selectedSeat);
        console.log("is a primary traveler");
        console.log(selectedSeat);
      }

      this.selectedMap = false;
    },
    goToSeatMap(i) {
      this.selectedMap = this.seatMaps[i];
      //this.selectedMap.segmentIndex = i;
    },
    hasSeats(j, l) {
      let seatmap = this.findMap(j, l);
      return seatmap?.seatsGroupedByRow?.length > 0;
    },
    findMap(j, l) {
      let segmentIndex = this.segmentMatrix[j][l];
      let seatmap = this.seatMaps.find((sMap) => {
        return sMap?.segmentIndex === segmentIndex;
      });
      return seatmap;
    },
    //find the segmentIndex for a given journey (j) and leg (l)
    findId(j, l) {
      return this.segmentMatrix[j][l];
    },
    //returns the journey (j) and leg (l) indices associated with a given SeatMap
    findIndices(seatMap) {
      let found = null;
      let segmentIndex = seatMap.segmentIndex;
      //console.log(segmentIndex);
      this.segmentMatrix.forEach((journey, j) => {
        journey.forEach((leg, l) => {
          if (leg === segmentIndex) {
            found = [j, l];
          }
        });
      });
      return found;
    },
    buildRequest(j, i) {
      var data = {
        departureAirport: this.journeys[j].legs[i].departingAirport,
        arrivalAirport: this.journeys[j].legs[i].arrivingAirport,
        airlineCode: this.journeys[j].legs[i].marketingAirline.code,
        flightNumber: this.journeys[j].legs[i].flightNumber,
        departureDate: this.journeys[j].legs[i].departingAt.date,
        bookingClass: this.journeys[j].legs[i].fareInfo.bookingClass,
      };
      var program = this.findProgramCode(
        this.passenger.programs,
        data.airlineCode
      );
      if (program) {
        data.traveler = {
          firstName: this.passenger.firstName,
          lastName: this.passenger.lastName,
          frequentFlyer: {
            company: data.airlineCode,
            number: program,
          },
        };
      }
      // console.log(data)
      return data;
    },
    getLoadingStatus(index) {
      return this.loadStatus[index];
    },
    updateLoadingStatus(index, bool) {
      //this.loadStatus[index] = obj;
      this.$set(this.loadStatus, index, bool);
    },
    findProgramCode(programs, provider) {
      if (programs) {
        for (var i = 0; i < programs.length; i++) {
          if (programs[i].providerCode == provider) {
            return programs[i].accountNumber;
          }
        }
      }
      return false;
    },
    async getAllMaps() {
      this.loading = true;

      /*
      this.segmentMatrix.forEach((journey, j) => {
        journey.forEach((seg, l) => {
          let body = this.buildRequest(j, l);
          this.$app
            .huddleLabsServerCall("amadeus/air/seat-map", body)
            .then((result) => {
              if (result.seatsGroupedByRow) {
                let seatMap = result;

                //append segmentIndex to seatMap
                seatMap.segmentIndex = seg;

                this.seatMaps[seg] = seatMap;
                this.loading = false;
              }
            });
        });
      });

      */

      await Promise.all(
        this.segmentMatrix.map((journey, j) => {
          journey.map(async (seg, l) => {
            let body = this.buildRequest(j, l);
            this.updateLoadingStatus(seg, true);
            await this.$app
              .huddleLabsServerCall("amadeus/air/seat-map", body)
              .then((result) => {
                if (result.seatsGroupedByRow) {
                  let seatMap = result;

                  //append segmentIndex to seatMap
                  seatMap.segmentIndex = seg;

                  //this.seatMaps[seg] = seatMap;
                  this.$set(this.seatMaps, seg, seatMap);
                }
                this.updateLoadingStatus(seg, false);
              });
          });
        })
      );

      this.loading = false;

      /*
      console.log("journey: " + j + " leg: " + l + " segmentIndex: " + s);
      if (l == this.journeys[j].legs.length - 1) {
        if (j == this.journeys.length - 1) {
          this.loading = false;
        } else {
          s++;
          j++;
          this.getAllMaps(j, 0, s);
        }
      } else {
        let body = this.buildRequest(j, l);
        this.$app
          .huddleLabsServerCall("amadeus/air/seat-map", body)
          .then((result) => {
            s++;
            if (result.seatsGroupedByRow) {
              let seatMap = result;

              //append segmentIndex to seatMap
              seatMap.segmentIndex = s;
              //this.$set(seatMap, 'segmentIndex', segmentIndex);

              this.seatMaps[s] = seatMap;
              //this.$set(this.seatMaps, 'segmentIndex', seatMap);
            }
            l++;
            this.getAllMaps(j, l, s);
          });
      }

      */
    },
    async getNdcSeatmaps(j, i) {
      this.loading = true;
      let seatMaps = [];
      let offer = this.flight.offer;

      let params = {
        meta: {
          stateful: false,
          normalizeResponse: true,
        },
        ownerCode: offer.ownerCode,
        responseId: offer.responseId,
        offerId: offer.offerId,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/travel/seatmap",
        params
      );

      if (result.data?.maps) {
        seatMaps = result.data.maps;

        seatMaps.forEach((seatMap) => {
          let segmentIndex = seatMap.segmentIndex;
          seatMap.responseId = result.data.responseId;
          seatMap.offerId = result.data.offerId;
          this.seatMaps[segmentIndex] = seatMap;
        });
      }

      this.loading = false;
    },
  },
  /*
  async getSeatmap(raw, i) {
    //this.loading = true

    this.$app
      .huddleLabsServerCall("amadeus/air/seat-map", raw)
      .then((result) => {
        this.seatMaps[i] = result;
      });
  },*/
  async mounted() {
    let profile;
    if (typeof this.guestIndex !== "undefined") {
      profile = this.$store.state.bookTravel.guests[this.guestIndex].profile;
    } else {
      profile = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    }

    // console.log(profile)
    this.passenger.programs = profile.travelerPrograms;
    this.passenger.name = profile.firstName + " " + profile.lastName;
    this.passenger.firstName = profile.firstName;
    this.passenger.lastName = profile.lastName;
    // console.log(this.activeTab)
    this.tab = this.activeTab;

    if (this.flight.offer) {
      await this.getNdcSeatmaps();
    } else {
      await this.getAllMaps();
    }
  },
};
</script>

<style scoped>
.seatmap-container {
  display: inline-block;
  overflow-y: scroll;
  max-height: 400px;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
